import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import ScreenshotSlideshow from '../components/screenshots/ScreenshotSlideshow';
import ScreenshotTimeline from '../components/screenshots/ScreenshotTimeline';
import { useRoleLabels } from '../hooks/useRoleLabels';

const ROLE_TABS = ['athlete', 'coach', 'guardian'];

const ScreenshotsPage: React.FC = () => {
    const { getRoleLabel } = useRoleLabels();
    const roleLabels = useMemo(
        () => ({
            athlete: getRoleLabel('athlete'),
            coach: getRoleLabel('coach'),
            guardian: getRoleLabel('parent'),
        }),
        [getRoleLabel]
    );
    const [searchParams, setSearchParams] = useSearchParams();
    const role = searchParams.get('role') || 'athlete';
    const view = searchParams.get('view');
    const showTimeline = view === 'timeline';

    const handleRoleChange = (_: React.SyntheticEvent, newRole: string) => {
        const next = new URLSearchParams(searchParams);
        next.set('role', newRole);
        setSearchParams(next, { replace: true });
    };

    if (showTimeline) {
        return (
            <Container maxWidth="xl" sx={{ py: 4 }}>
                <Typography variant="h3" align="center" gutterBottom>
                    See How It Works
                </Typography>
                <Typography variant="subtitle1" align="center" color="text.secondary" sx={{ mb: 4 }}>
                    Screenshots by role (timeline)
                </Typography>
                <ScreenshotTimeline />
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h3" align="center" gutterBottom>
                See How It Works
            </Typography>
            <Typography variant="subtitle1" align="center" color="text.secondary" sx={{ mb: 4 }}>
                Browse screenshots of the program experience for each role
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs
                    value={role}
                    onChange={handleRoleChange}
                    centered
                    aria-label="Select role"
                >
                    {ROLE_TABS.map(r => (
                        <Tab
                            key={r}
                            value={r}
                            label={roleLabels[r as keyof typeof roleLabels] || r}
                        />
                    ))}
                </Tabs>
            </Box>

            <ScreenshotSlideshow filterRole={role} />
        </Container>
    );
};

export default ScreenshotsPage;
